import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, TRANSLATION_KEY, {
  MODULE_HOME: 'Início',
  MODULE_HANA: 'Hana AI',
  MODULE_RECOGNITION: 'Reconhecimento',
  MODULE_PERFORMANCE: 'Desempenho',
  MODULE_CLIMATE: 'Clima',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Companhia',
  MODULE_ANALYTICS: 'Analítica',
  MODULE_ADMIN: 'Administração',
  MODULE_STATISTICS: 'Estatísticas',
  MODULE_REPORTS: 'Relatórios',
  MODULE_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitore seus processos e gere relatórios.',
  MODULE_HANA_TOOLTIP_DESCRIPTION: 'Analise os dados da sua empresa com Inteligência Artificial.',
  MODULE_PRODUCTS_SUBTITLE: 'PRODUTOS',
  MODULE_RECOGNITION_TOOLTIP_DESCRIPTION: 'Gerencie as medalhas concedidas pelos colaboradores.',
  MODULE_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Avalie o desempenho, através de objetivos e competências.',
  MODULE_CLIMATE_TOOLTIP_DESCRIPTION: 'Meça a cultura e satisfação da sua equipe.',
  MODULE_LEARNING_TOOLTIP_DESCRIPTION: 'Gerencie estratégias de aprendizado e potencialize as habilidades de suas equipes.',
  MODULE_ADMIN_TOOLTIP_DESCRIPTION: 'Gerencie seus usuários e as configurações da empresa.',
  MODULE_COMPANY_TOOLTIP_DESCRIPTION: 'Crie usuários e gerencie a estrutura organizacional.',
  MODULE_ACCOUNT: 'Conta',
  MODULE_ACCOUNT_TOOLTIP_DESCRIPTION: 'Gerencie os dados da conta e consulte o consumo de licenças.',
  MODULE_LOGS: 'Logs',
  MODULE_LOGS_TOOLTIP_DESCRIPTION: 'História das ações realizadas na conta.',
  MODULE_APPEARANCE: 'Aparência',
  MODULE_APPEARANCE_TOOLTIP_DESCRIPTION: 'Personalize o painel com a identidade organizacional.',
  MODULE_COMMUNICATION: 'Comunicação',
  MODULE_COMMUNICATION_TOOLTIP_DESCRIPTION: 'Personalize as notificações para seus usuários.',
  MODULE_AUTOMATIONS: 'Automatizações',
  MODULE_AUTOMATIONS_TOOLTIP_DESCRIPTION: 'Crie regras de automação para agilizar tarefas.',
  MODULE_COMPANY_USERS: 'Usuárias',
  MODULE_COMPANY_EXTRA_FIELDS: 'Atributos personalizados',
  MODULE_COMPANY_DEPARTMENTS: 'Departamentos',
  MODULE_COMPANY_JOBS: 'Empregos',
  MODULE_COMPANY_ORGCHART: 'Organização do organograma',
  // learning links
  LEARNING_LINK_CONTENT: 'Conteúdo',
  LEARNING_LINK_CONTENT_TOOLTIP_DESCRIPTION: 'Gerencie os cursos, trilhas de aprendizagem e outros recursos.',
  LEARNING_LINK_COURSES: 'Cursos',
  LEARNING_LINK_PATHS: 'Trilhas de aprendizagem',
  LEARNING_LINK_PROJECTS: 'Projetos',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Evolução de Skill XP',
  LEARNING_LINK_SKILL_XP_EVOLUTION_TOOLTIP_DESCRIPTION: 'Meça as habilidades de cada pessoa.',
  LEARNING_LINK_GAMIFICATION: 'Gamificação',
  LEARNING_LINK_GAMIFICATION_TOOLTIP_DESCRIPTION: 'Crie, gerencie e premie conquistas de aprendizado.',
  LEARNING_LINK_PROGRESS: 'Progresso',
  LEARNING_LINK_REWARDS: 'Recompensas',
  LEARNING_LINK_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitore seus processos e gere relatórios.',
  LEARNING_LINK_SHOP: 'Loja',
  LEARNING_LINK_SHOP_TOOLTIP_DESCRIPTION: 'Personalize sua loja virtual de conteúdo.',
  LEARNING_LINK_INTEGRATIONS: 'Integrações',
  LEARNING_LINK_INTEGRATIONS_TOOLTIP_DESCRIPTION: 'Conecte a plataforma com outros sistemas.',
  // submodules
  SUBMODULE_RESULTS: 'Resultados',
  SUBMODULE_RESULTS_TOOLTIP_DESCRIPTION: 'Consulte os resultados dos processos em que participa.',
  SUBMODULE_MY_TEAM: 'Minha Equipe',
  SUBMODULE_MY_TEAM_TOOLTIP_DESCRIPTION: 'Monitore os resultados da sua equipe.',
  SUBMODULE_ADMIN_RESULTS: 'Resultados',
  SUBMODULE_ADMIN_RESULTS_TOOLTIP_DESCRIPTION: 'Monitore o ranking de medalhas obtidas pelos seus colaboradores.',
  SUBMODULE_MEDALS_REQUESTS: 'Solicitação de Medalhas',
  SUBMODULE_MEDALS_REQUESTS_TOOLTIP_DESCRIPTION: 'Aprove ou rejeite as medalhas enviadas pelos colaboradores.',
  SUBMODULE_REWARDS: 'Recompensas',
  SUBMODULE_REWARDS_TOOLTIP_DESCRIPTION: 'Gerencie e entregue as recompensas resgatadas.',
  SUBMODULE_CONFIGURATION: 'Configuração',
  SUBMODULE_CONFIGURATION_TOOLTIP_DESCRIPTION: 'Crie medalhas, defina regras e mensagens.',
  SUBMODULE_RESULTS_PERFORMANCE: 'Resultados',
  SUBMODULE_RESULTS_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Meça o desempenho e o comprometimento das equipes.',
  SUBMODULE_COMPETENCES: 'Competências',
  SUBMODULE_COMPETENCES_TOOLTIP_DESCRIPTION: 'Crie e atribua avaliações de competências.',
  SUBMODULE_GOALS: 'Metas',
  SUBMODULE_GOALS_TOOLTIP_DESCRIPTION: 'Planeje e estabeleça seus compromissos de trabalho.',
  SUBMODULE_OKRS: 'OKRs',
  SUBMODULE_OKRS_TOOLTIP_DESCRIPTION: 'Visualize o progresso da estratégia empresarial e reconheça o esforço para cumprir os objetivos.',
  SUBMODULE_FEEDBACK: 'Feedback',
  SUBMODULE_FEEDBACK_TOOLTIP_DESCRIPTION: 'Meça os processos de feedback da sua companhia.',
  SUBMODULE_PID: 'Plano Individual de Desenvolvimento',
  SUBMODULE_PID_TOOLTIP_DESCRIPTION: 'Crie processos para fechar lacunas e promover o crescimento.',
  SUBMODULE_SUCCESSION_PLAN: 'Plano de Sucessão',
  SUBMODULE_SUCCESSION_PLAN_TOOLTIP_DESCRIPTION: 'Crie planos de ação para futuras vagas.',
  SUBMODULE_LINK_GOALS: 'Objetivos',
  SUBMODULE_LINK_ALIGNMENT: 'Alinhamento',
  SUBMODULE_LINK_CONFIGURATION: 'Configuração',
  SUBMODULE_CLIMATE_EVALUATION: 'Avaliações de Clima',
  SUBMODULE_CLIMATE_EVALUATION_TOOLTIP_DESCRIPTION: 'Acesse o questionário para mediar o clima organizacional.',
  SUBMODULE_SHORT_SURVEY: 'Pesquisas Curtas',
  SUBMODULE_SHORT_SURVEY_TOOLTIP_DESCRIPTION: 'Recolha informações de maneira rápida e fácil.',
  SUBMODULE_OTHER_EVALUATIONS: 'Outras Avaliações',
  SUBMODULE_OTHER_EVALUATIONS_TOOLTIP_DESCRIPTION: 'Avaliações adicionais, como riscos psicossociais.',
  SUBMODULE_CONFIGURATION_MEDALS: 'Medallas',
  SUBMODULE_CONFIGURATION_MESSAGES: 'Mensajes',
  SUBMODULE_CONFIGURATION_RULES_AND_PERMISSIONS: 'Regras e permissões',
  SUBMODULE_TALENT: 'Talent',
  SUBMODULE_LEARNING: 'E-Learning',
  SUBMODULE_NBOX: 'N-Box',
  SUBMODULE_NBOX_TOOLTIP_DESCRIPTION: 'Crie variáveis ​​de cruzamento de matrizes para visualizar dados.'
});